export default {
  feedbackPlaceholderText:"Put your feedback about this course",
  feedbackSubmitLabel:"Submit feedback",
  certificateLabel:"Certificate",
  doubtClearancePlaceholderText:"നിങ്ങളുടെ സംശയങ്ങൾ ഇവിടെ എഴുതുക",
  doubtClearanceSubmitLabel:"Submit Doubt",
}